/** 律所机构端路由前缀（对标 STORE_BASE=/store） */
export const FIRM_BASE = '/firm'

export function firmPath(suffix = ''): string {
  if (!suffix || suffix === '/') return FIRM_BASE
  return `${FIRM_BASE}${suffix.startsWith('/') ? suffix : `/${suffix}`}`
}

export function isFirmPath(path: string): boolean {
  return path === FIRM_BASE || path.startsWith(`${FIRM_BASE}/`)
}
